import { useQuery } from "react-query";
import { API_KEY_GET_LANDING_PAGE_STATUSES } from "../utils";
import { getLandingPageStatuses } from "../api";

export const useGetLandingPageStatuses = () => {
  return useQuery([API_KEY_GET_LANDING_PAGE_STATUSES], () =>
    getLandingPageStatuses()
  );
};
